import { IS_NOT_NULL_OR_UNDEFINED } from '../../utils';
import { Owner } from '../../project';
import { User } from './../../account';
import { IS_EMPTY } from '../../utils/stringUtils';

export const USERS_LIST_FOR_POPOVER = ({
	users,
	assigneeId,
	keepHavingStatus,
}: Input): Owner[] => {
	let usersList = [] as Owner[];
	try {
		if (IS_NOT_NULL_OR_UNDEFINED(users) && users.length > 0) {
			users
				.filter(
					(user: User) =>
						keepHavingStatus === 'ALL' || (keepHavingStatus || []).includes(user.accountStatus)
				)
				.map((user: User) => {
					let owner = {} as Owner;
					owner.userId = user.id;
					if (IS_EMPTY(user.firstName) && IS_EMPTY(user.lastName)) {
						owner.name = user.email;
					} else {
						owner.name = `${user.firstName || ''} ${user.lastName || ''}`;
					}
					owner.email = user.email;
					owner.selected = IS_NOT_NULL_OR_UNDEFINED(assigneeId) && user.id == assigneeId;
					owner.role = user.role;
					usersList.push(owner);
				});
			usersList = usersList.sort(
				(a, b) => 0 - (a.name.toLowerCase() > b.name.toLowerCase() ? -1 : 1)
			);
		}
	} catch (error) {
		console.log('USERS_LIST_FOR_POPOVER error: ', error);
	}

	return usersList;
};

interface Input {
	users: User[];
	assigneeId: number;
	// Allow-list, not an exclusion: an unrecognised or missing status is dropped.
	// 'ALL' skips the filter entirely — use it only for label resolution, never for options.
	keepHavingStatus: string[] | 'ALL';
}
